import { jsxs as x, jsx as r } from "react/jsx-runtime";
import * as s from "react";
import { cva as g } from "class-variance-authority";
import { cn as o } from "../../../lib/utils.js";
import { motion as f, AnimatePresence as h } from "framer-motion";
import { ChevronLeft as y } from "lucide-react";
const w = g("flex flex-col h-full bg-surface border-r border-border-color transition-all duration-700 ease-luxury relative z-30", {
  variants: {
    variant: {
      default: "shadow-subtle",
      glass: "bg-surface/40 backdrop-blur-3xl shadow-premium"
    },
    collapsed: {
      true: "w-[88px]",
      false: "w-56 md:w-72"
    }
  },
  defaultVariants: {
    variant: "glass",
    collapsed: !1
  }
}), N = s.forwardRef(({ className: t, variant: e, collapsed: a, onCollapsedChange: l, children: d, ...c }, p) => {
  const [n, i] = s.useState(a ?? !1), v = () => {
    const m = !n;
    i(m), l == null || l(m);
  };
  return x("div", { ref: p, className: o(
    w({ variant: e, collapsed: n }),
    "relative",
    // Add this - makes the collapse button position relative to sidebar
    t
  ), ...c, children: [d, r("button", { onClick: v, className: o("absolute -right-4 top-10 h-8 w-8 rounded-xl bg-surface border border-border-color shadow-luxury", "flex items-center justify-center text-text-secondary hover:text-lpr-teal dark:hover:text-lpr-gold", "transition-all duration-500 hover:scale-110 active:scale-90", "z-50 group/collapse"), "aria-label": n ? "Expand sidebar" : "Collapse sidebar", children: r(f.div, { animate: { rotate: n ? 180 : 0 }, transition: { type: "spring", stiffness: 400, damping: 25 }, children: r(y, { className: "h-4 w-4" }) }) })] });
});
N.displayName = "Sidebar";
const b = s.createContext({
  collapsed: !1
}), u = () => s.useContext(b), V = ({ collapsed: t, children: e }) => r(b.Provider, { value: { collapsed: t }, children: e }), S = s.forwardRef(({ className: t, ...e }, a) => {
  const { collapsed: l } = u();
  return r("div", { ref: a, className: o("flex items-center h-24 px-8 py-6 border-b border-border-color", l && "justify-center px-4", t), ...e });
});
S.displayName = "SidebarHeader";
const k = s.forwardRef(({ className: t, ...e }, a) => r("div", { ref: a, className: o("flex-1 overflow-y-auto py-8 custom-scrollbar", t), ...e }));
k.displayName = "SidebarContent";
const j = s.forwardRef(({ className: t, ...e }, a) => {
  const { collapsed: l } = u();
  return r("div", { ref: a, className: o("border-t border-border-color p-8", l && "p-4 flex justify-center", t), ...e });
});
j.displayName = "SidebarFooter";
const z = s.forwardRef(({ className: t, ...e }, a) => r("nav", { ref: a, className: o("flex flex-col gap-1 px-3", t), ...e }));
z.displayName = "SidebarNav";
const R = s.forwardRef(({ className: t, icon: e, badge: a, showBadge: l = !1, active: d, children: c, ...p }, n) => {
  const { collapsed: i } = u();
  return x("div", { className: "relative group/item px-4", children: [x("a", { ref: n, className: o("relative flex items-center gap-4 rounded-xl px-4 py-3.5 transition-all duration-500 ease-luxury overflow-hidden", d ? "text-lpr-teal dark:text-lpr-gold" : "text-text-secondary hover:text-text-primary hover:bg-border-color", i && "justify-center px-0 w-14 mx-auto gap-0", t), ...p, children: [r(h, { children: d && r(f.div, { layoutId: "sidebar-highlight", className: "absolute inset-0 bg-lpr-teal/5 dark:bg-lpr-gold/10 z-0", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }) }), e && r("span", { className: o("relative z-10 flex-shrink-0 transition-all duration-500", d ? "text-lpr-teal dark:text-lpr-gold scale-110" : "text-text-secondary group-hover/item:text-lpr-teal dark:group-hover/item:text-lpr-gold", i && "mx-auto"), children: e }), !i && r("span", { className: "relative z-10 flex-1 text-xs font-bold uppercase tracking-[0.15em] truncate", children: c }), !i && l && a !== void 0 && r("span", { className: o("relative z-10 flex h-5 min-w-[1.25rem] items-center justify-center rounded-lg px-1.5 text-[10px] font-black uppercase tracking-tight", d ? "bg-lpr-teal dark:bg-lpr-gold text-white dark:text-lpr-charcoal shadow-glow" : "bg-border-color text-text-secondary group-hover/item:bg-lpr-gold group-hover/item:text-lpr-charcoal"), children: a })] }), i && r("div", { className: o("absolute left-full top-1/2 -translate-y-1/2 ml-4 px-4 py-2 rounded-xl", "bg-surface backdrop-blur-2xl border border-border-color text-xs font-bold uppercase tracking-widest text-text-primary", "opacity-0 invisible scale-90 translate-x-2 group-hover/item:opacity-100 group-hover/item:visible group-hover/item:scale-100 group-hover/item:translate-x-0", "transition-all duration-500 ease-luxury shadow-premium pointer-events-none z-[100]"), children: c })] });
});
R.displayName = "SidebarNavItem";
export {
  N as Sidebar,
  k as SidebarContent,
  j as SidebarFooter,
  S as SidebarHeader,
  z as SidebarNav,
  R as SidebarNavItem,
  V as SidebarProvider,
  u as useSidebarContext
};
//# sourceMappingURL=Sidebar.js.map
